module.exports = "/_next/static/images/more_create-events-3f7f598141a4bd54aa324c44c7305653.jpg";